import { render, staticRenderFns } from "./Roles.vue?vue&type=template&id=023124e9&scoped=true"
import script from "./Roles.vue?vue&type=script&lang=js"
export * from "./Roles.vue?vue&type=script&lang=js"
import style0 from "./Roles.vue?vue&type=style&index=0&id=023124e9&prod&lang=scss&scoped=true"
import style1 from "./Roles.vue?vue&type=style&index=1&id=023124e9&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023124e9",
  null
  
)

export default component.exports